var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2463",
    "data-name": "Group 2463",
    transform: "translate(0.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M4.167,20a2.083,2.083,0,0,1-2-2.106L1.374,4.286H.667A.692.692,0,0,1,0,3.571a.692.692,0,0,1,.667-.714h4V1.786A1.861,1.861,0,0,1,5.154.522,1.6,1.6,0,0,1,6.33,0H9.667a1.6,1.6,0,0,1,1.179.522,1.862,1.862,0,0,1,.487,1.266V2.857h4A.692.692,0,0,1,16,3.571a.692.692,0,0,1-.667.714h-.707L13.832,17.9a2.069,2.069,0,0,1-2,2.1ZM3.5,17.813a.7.7,0,0,0,.668.759h7.667a.709.709,0,0,0,.668-.758L13.29,4.286H2.71ZM10,2.857V1.786a.371.371,0,0,0-.1-.253.317.317,0,0,0-.234-.1H6.333a.319.319,0,0,0-.236.1.37.37,0,0,0-.1.251V2.857Z",
    transform: "translate(-0.395)",
    fill: "#e51919"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2402",
    "data-name": "Rectangle 2402",
    width: 1.33,
    height: 11.393,
    rx: 0.665,
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 3.593, 5.698)",
    fill: "#e51919"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2403",
    "data-name": "Rectangle 2403",
    width: 1.331,
    height: 11.401,
    rx: 0.665,
    transform: "matrix(0.999, 0.052, -0.052, 0.999, 10.164, 5.644)",
    fill: "#e51919"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2404",
    "data-name": "Rectangle 2404",
    width: 1.33,
    height: 11.393,
    rx: 0.665,
    transform: "translate(6.806 5.671)",
    fill: "#e51919"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.b635f7d7df28e25bd6b1a0e1020de609.svg";
export { ForwardRef as ReactComponent };